import { createCustomError } from '@ori/error';
import { isValidProperty } from "./internals";
import { spaConfigContextInitialState } from "./spaConfigContext";

// SpaConfigContext overrides few attributes in SpaConfig and defines final type
// We want to pick those attributes by SpaConfig

export const ParseSpaConfigError = createCustomError('ParseSpaConfigError', {
  CONFIG_NOT_PROVIDED: 'No config provided!',
  MISSING_PROPERTY: 'Missing {0} config property!'
});
const requiredProperties = ['currentLanguage', 'graphqlUrl', 'tenant'];

/**
 * Takes a string and parses it as JSON. Throws errors f resulting config does not have required keys. Basic type with keys that are required is exported via type `RequiredSpaConfigContext`
 * @param config config in JSON value
 * @param additionalRequiredProperties Optional parameter that lets you choose more required values, on top of basic ones, which are gonna be tested too. Lets you choose required values from provided type.
 * @returns Parsed config value
 */
export function parseSpaConfig(config, additionalRequiredProperties = []) {
  if (!config) {
    throw new ParseSpaConfigError('CONFIG_NOT_PROVIDED');
  }
  const parsedConfig = JSON.parse(config);
  [...requiredProperties, ...additionalRequiredProperties].forEach(prop => {
    if (!isValidProperty(parsedConfig, String(prop))) {
      throw new ParseSpaConfigError('MISSING_PROPERTY', {
        messageParameters: [String(prop)]
      });
    }
  });
  return {
    // We should set default values to stay true to typings
    customerId: spaConfigContextInitialState.customerId,
    isFrontPage: spaConfigContextInitialState.isFrontPage,
    ...parsedConfig
  };
}
//# sourceMappingURL=parseSpaConfig.js.map